// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__11M2e","dragIcon":"Choice_dragIcon__TUsWQ","left":"Choice_left__3QCVf","input":"Choice_input__3BuND"};